module.exports = __webpack_public_path__ + "static/services2-fab7caa0885bf1443faee49f960fe2cc.jpg";